import React from 'react';
import { pageUrlService } from '@shared/services/pageUrlService';
import RecentUpdatesNotificationCard from '../RecentUpdatesNotificationCard';

/**
 * @typedef {object} ChangeDateRequestEditEventReviewNotificationProps
 * @property {Object} [notification]
 */

/**
 * @param {ChangeDateRequestEditEventReviewNotificationProps} props
 */
const ChangeDateRequestEditEventReviewNotification = props => {
  const { notification } = props;

  const redirectUrl = pageUrlService.getEditEventPageUrl(notification.EventId);

  return (
    <RecentUpdatesNotificationCard
      name={notification.Name}
      label='Date Change has been submitted.'
      notificationDaysAgo={notification.NotificationDaysAgo}
      redirectUrl={redirectUrl}
    />
  );
};

export default ChangeDateRequestEditEventReviewNotification;
